import Section9 from '@/components/RoutePage/SectionManager/Section9';
import SearchInput from '@/components/RouteToCityPage/SectionManager/SearchInput';
import React from 'react';

const SectionTetTicketCalendar = (props: any) => (
  <div>
    <SearchInput {...props} />
    <Section9 {...props} />
  </div>
);

export default SectionTetTicketCalendar;
